import { h } from "preact";
import { useSelector } from "react-redux";

import AppSidebar from "../AppSidebar.jsx";
import LinearLoadingIndicator from "../LinearLoadingIndicator.jsx";
import NaviDrawer from "../NaviDrawer.jsx";
import Toasts from "../Toasts.jsx";
import { classNames } from "../../helpers.js";

export default function CompanyLayout({ children, ...props }) {
  const isMobileView = useSelector((state) => state.ui.isMobileView);
  const loading = useSelector((state) => state.ui.loading);

  return (
    <div
      class={classNames(
        "app-layout",
        isMobileView && "app-layout--mobile-view"
      )}
    >
      <AppSidebar class="app-layout__sidebar" />
      <Toasts />
      <div class="app-layout__contentPreWrap app-layout__contentPreWrap--withHeader">
        {props.header && (
          <div class="app-layout__content-header">{props.header}</div>
        )}
        <div class="app-layout__contentWrap">
          {(props.loading || loading) && (
            <LinearLoadingIndicator class="app-layout__loading" />
          )}
          <main class="app-layout__content">{children}</main>
          {props.footer && (
            <footer class="app-layout__footer">{props.footer}</footer>
          )}
        </div>
        {isMobileView && <NaviDrawer />}
      </div>
    </div>
  );
}
